import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';
import ban from '../img/math.png'

export default class Modaladdroompresentsm extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                name_present : '', //ผู้นำเสนอ
              
                articletype:[],
                id_room:'',
                roompresent_date:'',
                roompresent_details:'',
                }

            
                this.handleSubmit = this.handleSubmit.bind(this);


                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
            
                this.onClickradio = this.onClickradio.bind(this);
                this.gettype = this.gettype.bind(this);
               
                this.linenotify = this.linenotify.bind(this);
                this.onChangedatesapa = this.onChangedatesapa.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
}

onChangedatesapa(value) {
    this.setState({ roompresent_date: value.target.value });
  }



linenotify = () => {


  const presentype_id =  this.state.articletype.filter((word) => word.presentype_id === this.state.send_type);
  var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
  datafrm.append("presentype_name", presentype_id[0].presentype_name);
 

 
      api.post('registercon/linenotifyaddarticle', datafrm)
          .then((res) => {
             // this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
          })
          .catch((err) => { alert("ไม่สำเร็จ " + err) })

 

}


                toggle = () => {
                this.setState({
                    modal: !this.state.modal
                });
                // this.props.selectatf();
                this.gettype();
                if (localStorage.getItem('register_typemamber') === '1' || localStorage.getItem('register_typemamber') === '2') {
                this.setState({ send_status: '2'})
                }
                }


                onClickradio = (nr) => () => {
                this.setState({
                    radio: nr,
                });

                };




            componentDidMount() {
                const { iduser } = this.props.iduser
                //   console.log(id_send);
                this.setState({ iduser:this.props.iduser})
                //   setTimeout(() => {
                //     //ภายใน
                //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
                //     .then(res => {
                //       console.log(res);
                //     //  this.setState({ bankname: res.data, loading: false })
                //       this.setState({ Expert: res.data})
                //     }) 
                //   }, 0);
            }


            gettype() {
                setTimeout(() => {
                api.get('registercon/selectroompresent')
                .then(res => {
                    console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                    this.setState({ articletype: res.data})
                }) 
                }, 0);
            }

            handleChangetype(event) {    this.setState({id_room: event.target.value});  }
            handleChangenamepresent(event) {   this.setState({roompresent_details: event.target.value});  }




 handleSubmit= (e) => {
  e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_room", this.state.id_room);
      datafrm.append("roompresent_datesm", this.state.roompresent_date);
      datafrm.append("roompresent_detailssm", this.state.roompresent_details);
      datafrm.append("roompresent_statussm", '1');
     

    api.post("registercon/Insertroompresentsm",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
            console.warn(res);
            console.log("response: ", res)
                    if (res.data = '200') {

                        Swal.fire({
                            title: 'ลงทะเบียนสำเร็จ',
                            text: "Successfully registered",
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'ตกลง'
                          }).then((result) => {
                            if (result.isConfirmed) {
                               window.location.href = '/Superadminroompresentsm'
                              // Swal.fire(
                              //   'Deleted!',
                              //   'Your file has been deleted.',
                              //   'success'
                              // )
                             // this.props.list();
                              //this.toggle()
                            }
                          })
                    
                    }else{
                    message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
          console.log(this.state.id_room)
          console.log(this.state.roompresent_date)
          console.log(this.state.roompresent_details)
        

          const items = this.state.articletype.map((articletype, i) => (
            <option  value={articletype.id_room} >{articletype.name_room} ความจุ {articletype.num_room} คน</option>
          ));


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="deep-purple" onClick={this.toggle}><MDBIcon icon="plus-square" />  เพิ่มห้องสัมมนา</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>เพิ่มห้อง</MDBModalHeader>
             <form 
                onSubmit={this.handleSubmit}
                 >
   
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
              <div>
<br/>
           
                            {/* <div className="mb-2">
                            <label><strong>สาขาการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangemajor}>
                                        <option>------กรุณาเลือกสาขาการนำเสนอ------</option>
                                         <option value="สาขาวิทยาศาสตร์และเทคโนโลยี" >สาขาวิทยาศาสตร์และเทคโนโลยี</option>
                                         <option value="สาขามนุษยศาสตร์และสังคมศาสตร์" >สาขามนุษยศาสตร์และสังคมศาสตร์</option>
                            </select>
                            </div> */}
               

                            <div className="mb-2">
                            <label><strong>ห้องสัมมนา</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype} required>
                              <option value="" >---เลือกห้องสัมมนา---</option>
                              {items}
                                      {/* <option value="s" >dd</option> */}
                                  
                                        
                                         {/* <option value="2" >นำเสนอแบบโปสเตอร์</option> */}
                            </select>
                            </div>

                            <div className="mt-2">
                                <label>วันที่สัมมนา</label>
                                <input
                                className="form-control"
                                type="date"
                                onChange={this.onChangedatesapa}
                                name="datesapa"
                                value={this.state.datesapa}
                                placeholder="กรุณาระบุวันที่สัมมนา"
                                required
                                />
                            </div>

                            <div className="mb-2">
                           <label><strong>รายละเอียด</strong></label>
                           <input className="form-control" onChange={this.handleChangenamepresent} name="roompresent_details"
                                    value={this.state.roompresent_details} placeholder="กรุณาระบุรายละเอียด" required />
                            </div>


              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
                 <MDBBtn color="primary" type='submit' >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
              </form>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
